class originalAccountListBannerCtrl {
  constructor($scope, operationService) {
    const activeSel = function () {
      if (operationService.hasPermit('original_account_collect')) {
        return 1;
      }
      return -1;
    };

    $scope.active = activeSel();
    $scope.typeChange = function typeChange(v) {
      $scope.active = v;
    };
  }
}

originalAccountListBannerCtrl.$inject = ['$scope', 'operationService'];
export default originalAccountListBannerCtrl;



// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/originalAccount/originalAccountListBannerCtrl.js